// Model imports
const {
  USER_FOLLOWING_CHANGE_PENDING,
  USER_FOLLOWING_CHANGE
} = require('./actions')
const UserModelRecord = require('./record')

// eslint-disable-next-line complexity
function userReducer(state, { type, payload }) {
  // Sanity check
  if (!payload || !(state instanceof UserModelRecord)) {
    return state
  }
  // Ignore actions that don't refer to this user
  if (payload.userId !== state.id) {
    return state
  }
  switch (type) {
    case USER_FOLLOWING_CHANGE: {
      const countDiff = followerCountDiff(payload)
      return state.merge({
        'follower_count': state['follower_count'] + countDiff,
        isFollowing: payload.isFollowing
      })
    }
    default:
      return state
  }
}

module.exports = userReducer

function followerCountDiff({ isFollowing }) {
  if (isFollowing === USER_FOLLOWING_CHANGE_PENDING) {
    return 0
  }
  return isFollowing ? +1 : -1
}
